<template>
  <div>

    <div class="container-fluid homeinner">

      <header>
        <h3>{{ content }}</h3>

      </header>
      <!-- home -->
      <div class="mt-5">
        <br/>  <br/>  <br/>
      <div class="col-md-12 mx-auto mt-3 pt-5 " hidden>
        <h2 align="center">The admission Steps</h2>
        <!-- <img src="../assets/welcome-bg.png" alt="img">
     <div class="user-bg" @click="showAlert"><b-icon icon="people-fill"></b-icon>
     <h1>Employee</h1>
     </div> -->






        <!-- <div class="user-bg2"><b-icon icon="person-plus-fill"></b-icon>
     <h1>Applicant</h1>
     </div>
     <div class="user-bg3"><b-icon icon="person-bounding-box"></b-icon>
     <h1>Student</h1>
     
     </div>
     <div class="user-bg4"><b-icon icon="person-circle"></b-icon>
     
     <h1>Alumni</h1>
     </div> -->


        <div class="">
          <div class="homeStep">
            <div class="step1">
              <img src="../assets/Step1.png" alt="img" width="97%">
            </div>
            <div class="text1">
              <h5 align="center">Register Yourself</h5>
              <p align="center">Create an account in your name.</p>

            </div>

            <div class="line">
              <img src="../assets/line.png" alt="img" width="95%">
            </div>

            <div class="text2">
              <h5 align="center">Verify Email</h5>
              <p align="center"> check if an email address is valid and properly formatted</p>

            </div>

            <div class="step2">
              <img src="../assets/Step2.png" alt="img" width="71%">
            </div>

            <div class="text3">
              <h5 align="center">Fill Application form</h5>
              <p align="center">Gather all the necessary information for filling out the form</p>

            </div>
            <div class="step3">
              <img src="../assets/Step3.png" alt="img" width="71%">
            </div>

            <div class="text4">
              <h5 align="center">Pay Application Fee</h5>
              <p align="center">When you submit your application, you will need to pay an application fee </p>

            </div>

            <div class="step4">
              <img src="../assets/Step4.png" alt="img" width="71%">
            </div>

            <div class="text5">
              <h5 align="center">Submit Application</h5>
              <p align="center">Flow automates how an application is submitted to an organization</p>

            </div>
            <div class="step5">
              <img src="../assets/Step5.png" alt="img" width="71%">
            </div>

            <div class="text6">
              <h5 align="center">Goals</h5>
              <p align="center">Complete and submit applications</p>

            </div>
            <div class="step6">
              <img src="../assets/Step6.png" alt="img" width="71%">
            </div>



          </div>
          <div class="homeStepM" hidden>
            <div class="row m-5">
              <div class="col-md-6">
                <div class="row">
              <div class="col-md-5 mt-3 col-sm-6">
                <img src="../assets/Step1m.png" alt="img" width="100%">
              </div>
              <div class="col-md-6 mt-3 col-sm-6">
                <h5 >Register Yourself</h5>
                <p >Gather all the necessary information for filling out the form</p>
              </div></div>
            </div>

            <div class="col-md-6">
                <div class="row">
              <div class="col-md-5 mt-3 col-sm-6">
                <img src="../assets/Step2m.png" alt="img" width="100%">
              </div>
              <div class="col-md-6 mt-3 col-sm-6">
                <h5>Verify Email</h5>
              <p> check if an email address is valid and properly formatted</p>
              </div></div>
            </div>

            <div class="col-md-6">
                <div class="row">
              <div class="col-md-5 mt-3 col-sm-6">
                <img src="../assets/Step3m.png" alt="img" width="100%">
              </div>
              <div class="col-md-6 mt-3 col-sm-6">
                <h5>Fill Application form</h5>
              <p>Gather all the necessary information for filling out the form</p>
              </div></div>
            </div>
           
            <div class="col-md-6">
                <div class="row">
              <div class="col-md-5 mt-3 col-sm-6">
                <img src="../assets/Step4m.png" alt="img" width="100%">
              </div>
              <div class="col-md-6 mt-3 col-sm-6">
                <h5 >Pay Application Fee</h5>
              <p>When you submit your application, you will need to pay an application fee </p>
              </div></div>
            </div>

            <div class="col-md-6">
                <div class="row">
              <div class="col-md-5 mt-3 col-sm-6"> 
                <img src="../assets/Step5m.png" alt="img" width="100%">
              </div>
              <div class="col-md-6 mt-3 col-sm-6">
                <h5>Submit Application</h5>
              <p>Flow automates how an application is submitted to an organization</p>
              </div></div>
            </div>


            <div class="col-md-6">
                <div class="row">
              <div class="col-md-5 mt-3 col-sm-6">
                <img src="../assets/Step6m.png" alt="img" width="100%">
              </div>
              <div class="col-md-6 mt-3 col-sm-6">
                <h5>Goals</h5>
              <p>Complete and submit applications</p>
              </div></div>
            </div>
            
            </div>
          </div>


          <div class="clearfx"></div>
        </div>



      </div>




      <div class="col-md-4 mx-auto ">
        <b-alert :show="dismissCountDown" dismissible variant="warning" @dismissed="dismissCountDown"
          @dismiss-count-down="countDownChanged">
          <h5>Congratulations, you became a student </h5>
          <p>Now You become a student , your login as applicant will be suspended and now you will be directed to create
            your student Account and Email</p>
          <p>You can <b-link to="/CreateStudentAccount"> Click here </b-link> to start or you will be redirected
            automatically after count down Stops </p>
          <p>This alert will dismiss after {{ dismissCountDown }} seconds...</p>
          <b-progress variant="warning" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
        </b-alert>
      </div>
</div>
    </div>

  </div>
</template>

<script>
import ApplicantDataServices from '../services/Applicant/ApplicantData.services';
//import UserService from '../services/user.service';

export default {
  beforeCreate: function () {
    document.body.className = 'home-bg';
  },

  name: 'Home',
  components: {

  },
  data() {
    return {
      content: '',
      dismissSecs: 60,
      dismissCountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  },
  mounted() {
    // UserService.getPublicContent().then(
    //   response => {
    //     this.content = response.data;
    //   },
    //   error => {
    //     this.content =
    //       (error.response && error.response.data) ||
    //       error.message ||
    //       error.toString();
    //   }
    // );
    ApplicantDataServices.CheckApplicantIsStudent(this.currentUser.UserIDSerial).then(response => {
      if (Array.isArray(response.data)) {
        this.dismissCountDown = 60
        this.showDismissibleAlert = true,
          localStorage.student = JSON.stringify(response.data)
        setTimeout(() => {
          this.$router.push('/CreateStudentAccount')
        }, 60000)
      }
    }, error => {
      this.message =
        (error.response && error.response.data && error.response.data.Message) ||
        error.message ||
        error.toString();
      if (error.response.status == 404) this.message = ''
    })
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user
    },

  }
};
</script>
<style scoped>
body {
  background-image: url(../assets/testbg.jpg);
  width: 100%;
}

.container-fluid {





  padding: 0px !important;
  margin-top: -3rem !important;
}

.home {
  padding: 100px 20px;
  text-align: center;
  position: relative;
}

.home img {
  width: 100%;
}

.user-bg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border: 2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  top: 22%;
  left: 12%;
  font-size: 3rem;
  color: #fff;
}

.user-bg h1 {
  font-size: 1.8rem;
  color: #fff;
  margin-bottom: -10px;
  left: -26px;
  position: absolute;

}

.user-bg2 h1 {
  font-size: 1.8rem;
  color: #fff;
  margin-bottom: -10px;
  left: -26px;
  position: absolute;

}

.user-bg3 h1 {
  font-size: 1.8rem;
  color: #fff;
  margin-bottom: -10px;
  left: -20px;
  position: absolute;

}

.user-bg4 h1 {
  font-size: 1.8rem;
  color: #fff;
  margin-bottom: -10px;
  left: -6px;
  position: absolute;

}


.user-bg2 {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border: 2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  top: 22%;
  right: 12%;
  font-size: 3rem;
  color: #fff;
}

.user-bg3 {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border: 2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  bottom: 22%;
  left: 12%;
  font-size: 3rem;
  color: #fff;
}

.user-bg4 {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border: 2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  bottom: 22%;
  right: 12%;
  font-size: 3rem;
  color: #fff;
}

.active {
  border: 2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}

.user-bg:hover {
  border: 2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}

.user-bg2:hover {
  border: 2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}

.user-bg3:hover {
  border: 2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}

.user-bg4:hover {
  border: 2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}

.alert-dismissible {
  margin-top: 00px;

}

.homeStep {
  position: relative;

  clear: both;
  height: 500px !important;
}

.homeStep .step1 {
  position: absolute;
  left: 11.52%;
  right: 77.93%;
  /* top: 46.35%; */
  bottom: 45.09%;
}

.homeStep .text1 {
  position: absolute;
  left: 9.59%;
  right: 64.23%;
  top: 59%;
  /* bottom: 46.97%; */
  padding: 25px;
  width: 200px;
}

.homeStep .line {
  position: absolute;
  left: 10%;
  right: 54.63%;
  top: 55.76%;
  bottom: 43.09%;
  width: 90%;

}

.homeStep .step2 {
  position: absolute;
  /* width: 202.65px; */
  /* height: 234.98px; */
  left: 377.65px;
  top: 314px;
}

.homeStep .text2 {
  position: absolute;
  left: 23.59%;
  right: 64.23%;
  top: 21%;
  /* bottom: 46.97%; */
  padding: 25px;
  width: 200px;
}

.homeStep .step3 {
  position: absolute;
  /* width: 202.65px; */
  /* height: 234.98px; */
  left: 586.19px;
  top: 111px;
}

.homeStep .text3 {
  position: absolute;
  left: 38.59%;
  right: 64.23%;
  top: 59%;
  /* bottom: 46.97%; */
  padding: 25px;
  width: 200px;
}

.homeStep .step4 {
  position: absolute;

  left: 789.71px;
  top: 314px;
}

.homeStep .text4 {
  position: absolute;
  left: 51.59%;
  right: 64.23%;
  top: 21%;
  /* bottom: 46.97%; */
  padding: 25px;
  width: 200px;
}

.homeStep .step5 {
  position: absolute;

  left: 998px;
  top: 111px;
}

.homeStep .text5 {
  position: absolute;
  left: 66.59%;
  right: 64.23%;
  top: 59%;
  /* bottom: 46.97%; */
  padding: 25px;
  width: 200px;
}

.homeStep .step6 {
  position: absolute;

  left: 1202.77px;
  top: 314px;
}

.homeStep .text5 {
  position: absolute;
  left: 66.59%;
  right: 64.23%;
  top: 61%;
  /* bottom: 46.97%; */
  padding: 25px;
  width: 200px;
}

.homeStep .text6 {
  position: absolute;
  left: 79.59%;
  right: 60.23%;
  top: 21%;
  /* bottom: 46.97%; */
  padding: 25px;
  width: 200px;
}
.homeinner{
  background-image: url(../assets/admission.jpeg);
  width: 100%;
  background-size:cover;
  height: 800px;


}

@media only screen and (max-width: 1200px) {
  .homeStep {
  display: none;
  }
  .homeStepM {
  display:block !important;
  }
}



@import url('../assets/style.css');
</style>

